import { render, staticRenderFns } from "./ParagraphMaterials.vue?vue&type=template&id=1f3a61f0"
import script from "./ParagraphMaterials.vue?vue&type=script&lang=js"
export * from "./ParagraphMaterials.vue?vue&type=script&lang=js"
import style0 from "./ParagraphMaterials.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports